// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"136":"561df7a9","491":"5ee822e2","603":"35e98565","635":"6308962b","667":"e213d903","697":"349179a7","859":"4649b21f","909":"b3aa7384"}[chunkId] + ".chunk.js";
};